export default __webpack_public_path__ + "media/images/react_icons/logged_user-28b9f7f19b9d54998dd824aefa4ede09.svg";